__turbopack_context__.v({
  "embedPlaylistApp": "PlaylistWrapper-module-scss-module__f2dpwa__embedPlaylistApp",
  "expanded": "PlaylistWrapper-module-scss-module__f2dpwa__expanded",
  "hidden": "PlaylistWrapper-module-scss-module__f2dpwa__hidden",
  "mobile": "PlaylistWrapper-module-scss-module__f2dpwa__mobile",
});
